(function ($) {
    $(function () {
        $('.social-media-share__single-button').on('click', function (e) {
            var social = $(this).data('social');
            var container = $(this).parents('.social-media-share__buttons');

            var title = $(container).data('title');
            var url = $(container).data('url');

            switch (social) {
                case 'facebook':
                    fb_share(url);
                    e.preventDefault();
                    return false;
                    break;

                case 'twitter':
                    tw_share(url, '');
                    e.preventDefault();
                    return false;
                    break;

                case 'draugiem':
                    draugiem_share(url, title);
                    e.preventDefault();
                    return false;
                    break;

                case 'google-plus':
                    googleplus_share(url, title);
                    e.preventDefault();
                    return false;
                    break;
            }
        });
    });
})(jQuery);